<div id="mySvgContainer" class="w-full h-fit overflow-auto">
    <div
        (dblclick)="onDoubleClick($event)"
        [ngClass]="isVertical() ? 'verticalSvgContainer' : 'horizontalSvgContainer'"
        #svgContainer></div>
</div>
